import { useState } from 'react';

/**
 * The company artwork. An SVG at /logo.svg is preferred and the PNG is the fallback, so dropping
 * a vector file into apps/web/public replaces the raster everywhere without a code change.
 * `logo-mark.png` is the square mark on its own, for tiles and small spaces.
 */
const LOCKUP = ['/logo.svg', '/logo.png'];

/** Full lockup (mark + wordmark). */
export function BrandLogo({ className = '', height }: { className?: string; height?: number }) {
  const [i, setI] = useState(0);
  const src = LOCKUP[i] ?? LOCKUP[LOCKUP.length - 1]!;
  return (
    <img
      src={src}
      alt="SIVA Logistics"
      className={`brand-logo ${className}`.trim()}
      {...(height ? { style: { height, width: 'auto' } } : {})}
      onError={() => setI((n) => Math.min(n + 1, LOCKUP.length - 1))}
    />
  );
}

/** The square mark, on the brand's dark tile so it reads on any background. */
export function BrandMark({ size = 40, className = '' }: { size?: number; className?: string }) {
  return (
    <span
      className={`brand-mark ${className}`.trim()}
      style={{ width: size, height: size }}
      aria-hidden="true"
    >
      <img src="/logo-mark.png" alt="" />
    </span>
  );
}
